import {NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {ContentSearchModule} from "../content-search/content-search.module";
import {SharedModule} from "../shared/shared.module";

import {ProductLineComponent} from "./components/product-line/product-line.component";
import {QuickShopComponent} from "./quick-shop.component";
import {DiscountMessagePopoverComponent} from "./components/discount-message-popover/discount-message-popover.component";

@NgModule({
    imports: [
        SharedModule,
        FormsModule,
        ContentSearchModule
    ],
    declarations: [
       QuickShopComponent,
       ProductLineComponent,
       DiscountMessagePopoverComponent
    ],
    exports: [
        QuickShopComponent
    ],
    providers: [
    ]
})
export class QuickShopModule {
}
